import React, { useState } from 'react';
import styles from "./styles.module.css";
import { IoLogoWhatsapp } from "react-icons/io";
import Footer from '../footer';

const Galery: React.FC<{ bolos }> = (props) => {

    const [selectedImg, setSelectedImg] = useState('');
    const [permalink, setPermalink] = useState('');
    const [abreModal, setAbreModal] = useState(false);

    function handleClickBolos(uri, permalink) {
        setSelectedImg(uri);
        setPermalink(permalink)
        setAbreModal(true);
    }

    function renderBolos() {
        return (
            props.bolos.map((bolo) => {
                if(bolo.url && bolo.url !==""){
                    return (
                        <div className={styles.col} key={bolo.media_url} onClick={() => handleClickBolos(bolo.media_url, bolo.permalink)}>
                            <img className={styles.bolos} src={bolo.media_url} alt={bolo.media_url}></img>
                        </div>
                    )
                } else {
                    return(<></>)
                }
                
            })
        )
    }

    function renderModalBolo() {
        if (abreModal)
            return (
                <div className={styles.modal}>
                    <input type="button" value="X" className={styles.closebytton} onClick={() => setAbreModal(false)} />
                    <img className={styles.imggalery} src={selectedImg} alt={selectedImg}></img>
                    <div className={styles.chamaNoZap}>
                        <label className={styles.textoZap}>FAZER UM PEDIDO</label>
                        <a href={`https://wa.me/+556296874973/?text=Olá%20gostei%20deste%20produto,%20gostaria%20de%20fazer%20um%20orçamento.%20${permalink}`} target="_blank" rel="next noopener noreferrer" className={styles.stretch}>
                            <IoLogoWhatsapp size='30' color="rgb(114, 187, 104)" className={styles.zapicon} />
                        </a>

                    </div>
                </div>
            )
    }

    return (
        <div>
            <div className={styles.container}>
                <div className={styles.row}>
                    {renderBolos()}
                </div>
            </div>
            {renderModalBolo()}
            <Footer/>
        </div>

    )

}


export default Galery;